import { Entity } from '@backstage/catalog-model';
import {
  DefaultEntityFilters,
  EntityFilter,
} from '@backstage/plugin-catalog-react';

// Frontend-only on purpose: a getCatalogFilters here would be sent to the
// catalog backend, which has no "not equal" filter and would include instead.
export class EntityExcludeTagFilter implements EntityFilter {
  readonly values: string[];

  constructor(values: string[]) {
    this.values = values;
  }

  filterEntity(entity: Entity): boolean {
    const tags = entity.metadata.tags ?? [];
    return !this.values.some(v => tags.includes(v));
  }

  toQueryValue(): string[] {
    return this.values;
  }
}

export type CatalogEntityFilters = DefaultEntityFilters & {
  excludeTags?: EntityExcludeTagFilter;
};
